import React from 'react';
import { Button } from './ui/button';
import { Clock, ArrowRight, Trophy, Sparkles } from 'lucide-react';

const TrialExpiredModal = ({ daysUsed = 7, pointsEarned = 0, salesPageUrl }) => {
  const handleSignUp = () => {
    window.open(salesPageUrl, '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl max-w-lg w-full p-6 sm:p-8 animate-fade-in">
        {/* Icon */}
        <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <Clock className="text-amber-400" size={32} />
        </div>

        {/* Title */}
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white text-center mb-3">
          Your Free Trial Has Ended
        </h2>

        <p className="text-zinc-400 text-center mb-6">
          Thanks for trying RxGRIT! Your 7-day trial is complete, but your journey doesn't have to stop here.
        </p>

        {/* Stats */}
        {pointsEarned > 0 && (
          <div className="bg-zinc-800/50 rounded-xl p-4 mb-6 flex items-center justify-center gap-3">
            <Trophy className="text-[#EFB342]" size={24} />
            <p className="text-white">
              You earned <span className="font-bold text-[#EFB342]">{pointsEarned} points</span> during your trial!
            </p>
          </div>
        )}

        {/* Benefits reminder */}
        <div className="space-y-3 mb-6">
          <p className="text-zinc-300 text-sm font-medium">When you join RxGRIT, you'll get:</p>
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Sparkles size={16} className="text-[#EFB342]" />
              <span>Unlimited access to daily challenges</span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Sparkles size={16} className="text-[#EFB342]" />
              <span>Exclusive Member Toolbox resources</span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Sparkles size={16} className="text-[#EFB342]" />
              <span>Discounted 1:1 coaching opportunities</span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Sparkles size={16} className="text-[#EFB342]" />
              <span>Keep building on your progress</span>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <Button
          onClick={handleSignUp}
          className="w-full bg-[#EFB342] text-black hover:bg-[#D99F30] font-semibold py-6 text-lg"
          data-testid="trial-expired-signup-btn"
        >
          Join RxGRIT Now
          <ArrowRight className="ml-2" size={20} />
        </Button>

        <p className="text-xs text-zinc-500 text-center mt-4">
          Questions? Contact us at hello@buildnutrition.ca
        </p>
      </div>
    </div>
  );
};

export default TrialExpiredModal;
